export const paymentMethods = [
  { label: 'Apple Pay', value: 'APPLE_PAY' },
  { label: 'Card', value: 'CARD' },
  { label: 'Google Pay', value: 'GOOGLE_PAY' },
  { label: 'Open Banking', value: 'OPEN_BANKING' },
  { label: 'PayPal', value: 'PAYPAL' },
];
